module.exports = __webpack_public_path__ + "img/veronika.9a215fcd.png";